import { logger } from "../../analytics/logger";
import { AnalyticsClient } from "./analyticsClient";

export const analyticsClientStub: AnalyticsClient = {
  logger,
};
